import routingMiddleware from "./routingMiddleware";

export default {
  routingMiddleware
};
